import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useWishlist } from '../../../hooks/useWishlist';

const defaultFeaturedCars = [
  {
    id: 7,
    name: '2016 Honda Pilot EX',
    price: 14995,
    mileage: '132,450',
    location: 'Fayetteville, GA',
    badge: 'Best Value',
    images: [
      'https://static.readdy.ai/image/e5292f43a8fca29a2b9f75d3d42cfb52/957de0cbdaf6ff81d22366c93b441658.jpeg',
      'https://static.readdy.ai/image/e5292f43a8fca29a2b9f75d3d42cfb52/651cead584827d2efaaa08e80b315b81.jpeg',
      'https://static.readdy.ai/image/e5292f43a8fca29a2b9f75d3d42cfb52/634cdb6ee5484fe4ae1c377fce9227b1.jpeg',
      'https://static.readdy.ai/image/e5292f43a8fca29a2b9f75d3d42cfb52/179a1906a944296f8dadc9225962e458.jpeg'
    ]
  },
  {
    id: 38,
    name: '2022 Toyota RAV4 XLE',
    price: 12995,
    mileage: '18,200',
    location: 'Fayetteville, GA',
    badge: 'Just Arrived',
    images: [
      'https://static.readdy.ai/image/e5292f43a8fca29a2b9f75d3d42cfb52/7ce8fa43afed15be988f5b4188f5d5ff.webp',
      'https://public.readdy.ai/ai/img_res/a29f0b59f275ae18dcea32bb38c06c32.jpg',
      'https://readdy.ai/api/search-image?query=side%20profile%20view%20of%20white%202022%20Toyota%20RAV4%20XLE%20highlighting%20the%20sleek%20body%20lines%20and%20alloy%20wheels%20in%20professional%20automotive%20studio%20with%20clean%20white%20background&width=800&height=600&seq=car2side2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=rear%20cargo%20area%20of%202022%20Toyota%20RAV4%20XLE%20showing%20spacious%20trunk%20space%20and%20folding%20seats%20in%20professional%20automotive%20photography%20with%20white%20background%20and%20bright%20lighting&width=800&height=600&seq=car2cargo2&orientation=landscape'
    ]
  },
  {
    id: 39,
    name: '2020 Ford F-150 XLT',
    price: 34995,
    mileage: '45,800',
    location: 'Fayetteville, GA',
    badge: 'Popular',
    images: [
      'https://readdy.ai/api/search-image?query=powerful%20blue%202020%20Ford%20F150%20XLT%20pickup%20truck%20displayed%20in%20professional%20automotive%20photography%20studio%20with%20clean%20white%20background%20and%20dramatic%20lighting%20emphasizing%20the%20truck%20rugged%20capability%20and%20bold%20design&width=800&height=600&seq=car3&orientation=landscape',
      'https://readdy.ai/api/search-image?query=rugged%20interior%20of%202020%20Ford%20F150%20XLT%20showing%20spacious%20cabin%20with%20durable%20seats%20modern%20dashboard%20and%20center%20console%20in%20professional%20automotive%20photography%20with%20white%20background&width=800&height=600&seq=car3int3&orientation=landscape',
      'https://readdy.ai/api/search-image?query=truck%20bed%20view%20of%202020%20Ford%20F150%20XLT%20showing%20spacious%20cargo%20area%20and%20bed%20liner%20in%20professional%20automotive%20photography%20with%20clean%20white%20background&width=800&height=600&seq=car3bed3&orientation=landscape',
      'https://readdy.ai/api/search-image?query=front%20grille%20and%20headlights%20close%20up%20of%20blue%202020%20Ford%20F150%20XLT%20showing%20bold%20design%20details%20in%20professional%20automotive%20studio%20with%20white%20background&width=800&height=600&seq=car3front3&orientation=landscape'
    ]
  },
  {
    id: 40,
    name: '2023 Chevrolet Equinox LT',
    price: 27995,
    mileage: '12,500',
    location: 'Fayetteville, GA',
    badge: 'Low Miles',
    images: [
      'https://readdy.ai/api/search-image?query=elegant%20black%202023%20Chevrolet%20Equinox%20LT%20crossover%20SUV%20showcased%20in%20professional%20automotive%20studio%20with%20pristine%20white%20minimalist%20background%20and%20sophisticated%20lighting%20highlighting%20the%20vehicle%20sleek%20modern%20styling&width=800&height=600&seq=car4&orientation=landscape',
      'https://readdy.ai/api/search-image?query=modern%20interior%20of%202023%20Chevrolet%20Equinox%20LT%20featuring%20touchscreen%20display%20comfortable%20seating%20and%20contemporary%20design%20in%20professional%20automotive%20photography%20with%20white%20background&width=800&height=600&seq=car4int4&orientation=landscape',
      'https://readdy.ai/api/search-image?query=rear%20view%20of%20black%202023%20Chevrolet%20Equinox%20LT%20showing%20LED%20taillights%20and%20sleek%20design%20in%20professional%20automotive%20studio%20with%20clean%20white%20background&width=800&height=600&seq=car4rear4&orientation=landscape',
      'https://readdy.ai/api/search-image?query=alloy%20wheel%20and%20tire%20close%20up%20of%202023%20Chevrolet%20Equinox%20LT%20showing%20premium%20wheel%20design%20in%20professional%20automotive%20photography%20with%20white%20background&width=800&height=600&seq=car4wheel4&orientation=landscape'
    ]
  },
  {
    id: 41,
    name: '2021 Nissan Altima SR',
    price: 22995,
    mileage: '28,900',
    location: 'Fayetteville, GA',
    badge: 'Great Deal',
    images: [
      'https://readdy.ai/api/search-image?query=sporty%20red%202021%20Nissan%20Altima%20SR%20sedan%20presented%20in%20professional%20automotive%20photography%20studio%20with%20clean%20white%20background%20and%20dynamic%20lighting%20showcasing%20the%20vehicle%20athletic%20design%20and%20premium%20appearance&width=800&height=600&seq=car5&orientation=landscape',
      'https://readdy.ai/api/search-image?query=sporty%20interior%20of%202021%20Nissan%20Altima%20SR%20showing%20sport%20seats%20steering%20wheel%20and%20modern%20dashboard%20in%20professional%20automotive%20photography%20with%20white%20background&width=800&height=600&seq=car5int5&orientation=landscape',
      'https://readdy.ai/api/search-image?query=side%20profile%20of%20red%202021%20Nissan%20Altima%20SR%20highlighting%20aerodynamic%20design%20and%20sporty%20character%20in%20professional%20automotive%20studio%20with%20clean%20white%20background&width=800&height=600&seq=car5side5&orientation=landscape',
      'https://readdy.ai/api/search-image?query=front%20view%20of%20red%202021%20Nissan%20Altima%20SR%20showing%20aggressive%20grille%20and%20LED%20headlights%20in%20professional%20automotive%20photography%20with%20white%20background&width=800&height=600&seq=car5front5&orientation=landscape'
    ]
  }
];

/* -------------------------------------------------
   IndexedDB Helper Functions
------------------------------------------------- */
const DB_NAME = 'CarInventoryDB';
const DB_VERSION = 1;
const STORE_NAME = 'carImages';

function openDB(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    
    request.onerror = () => reject(request.error);
    request.onsuccess = () => resolve(request.result);
    
    request.onupgradeneeded = (event) => {
      const db = (event.target as IDBOpenDBRequest).result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };
  });
}

async function loadFromIndexedDB(key: string): Promise<any> {
  try {
    const db = await openDB();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction([STORE_NAME], 'readonly');
      const store = transaction.objectStore(STORE_NAME);
      const request = store.get(key);
      
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });
  } catch (error) {
    console.error('IndexedDB error:', error);
    return null;
  }
}

export default function FeaturedInventory() {
  const navigate = useNavigate();
  const [hoveredCard, setHoveredCard] = useState<number | null>(null);
  const [currentImageIndex, setCurrentImageIndex] = useState<Record<number, number>>({});
  const [featuredCars, setFeaturedCars] = useState(defaultFeaturedCars);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxCarId, setLightboxCarId] = useState<number | null>(null);
  const [lightboxImageIndex, setLightboxImageIndex] = useState(0);
  const [selectedForCompare, setSelectedForCompare] = useState<number[]>([]);
  const { isInWishlist, toggleWishlist } = useWishlist();

  // Load saved images from IndexedDB
  useEffect(() => {
    async function loadSavedImages() {
      try {
        const savedCars = await loadFromIndexedDB('car-inventory-images');
        if (savedCars && Array.isArray(savedCars)) {
          // Convert the saved format to the display format
          const updatedCars = defaultFeaturedCars.map(car => {
            const savedCar = savedCars.find((c: any) => c.id === car.id);
            if (savedCar && savedCar.images && savedCar.images.length > 0) {
              return {
                ...car,
                images: savedCar.images.map((img: any) => img.url)
              };
            }
            return car;
          });
          setFeaturedCars(updatedCars);
        }
      } catch (error) {
        console.error('Error loading saved images:', error);
      }
    }
    
    loadSavedImages();
  }, []);

  // Close lightbox on Escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && lightboxOpen) {
        closeLightbox();
      }
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [lightboxOpen]);

  // Listen for vehicle updates from admin panel
  useEffect(() => {
    const handleVehiclesUpdate = async () => {
      try {
        const savedCars = await loadFromIndexedDB('car-inventory-images');
        if (savedCars && Array.isArray(savedCars)) {
          const updatedCars = defaultFeaturedCars.map(car => {
            const savedCar = savedCars.find((c: any) => c.id === car.id);
            if (savedCar && savedCar.images && savedCar.images.length > 0) {
              return {
                ...car,
                images: savedCar.images.map((img: any) => img.url)
              };
            }
            return car;
          });
          setFeaturedCars(updatedCars);
        }
      } catch (error) {
        console.error('Error loading updated images:', error);
      }
    };

    window.addEventListener('vehiclesUpdated', handleVehiclesUpdate);
    return () => window.removeEventListener('vehiclesUpdated', handleVehiclesUpdate);
  }, []);

  const handlePrevImage = (carId: number, totalImages: number, e: React.MouseEvent) => {
    e.stopPropagation();
    setCurrentImageIndex(prev => ({
      ...prev,
      [carId]: ((prev[carId] || 0) - 1 + totalImages) % totalImages
    }));
  };

  const handleNextImage = (carId: number, totalImages: number, e: React.MouseEvent) => {
    e.stopPropagation();
    setCurrentImageIndex(prev => ({
      ...prev,
      [carId]: ((prev[carId] || 0) + 1) % totalImages
    }));
  };

  const openLightbox = (carId: number, imageIndex: number) => {
    setLightboxCarId(carId);
    setLightboxImageIndex(imageIndex);
    setLightboxOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setLightboxCarId(null);
    document.body.style.overflow = 'auto';
  };

  const lightboxPrevImage = () => {
    if (lightboxCarId) {
      const car = featuredCars.find(c => c.id === lightboxCarId);
      if (car) {
        setLightboxImageIndex((prev) => (prev - 1 + car.images.length) % car.images.length);
      }
    }
  };

  const lightboxNextImage = () => {
    if (lightboxCarId) {
      const car = featuredCars.find(c => c.id === lightboxCarId);
      if (car) {
        setLightboxImageIndex((prev) => (prev + 1) % car.images.length);
      }
    }
  };

  const currentLightboxCar = lightboxCarId ? featuredCars.find(c => c.id === lightboxCarId) : null;

  const handleViewDetails = (car: typeof defaultFeaturedCars[0]) => {
    navigate('/vehicle-details', { state: { vehicle: car } });
  };

  const toggleCompareSelection = (carId: number, e: React.MouseEvent) => {
    e.stopPropagation();
    setSelectedForCompare(prev => {
      if (prev.includes(carId)) {
        return prev.filter(id => id !== carId);
      } else if (prev.length < 4) {
        return [...prev, carId];
      }
      return prev;
    });
  };

  const handleWishlistToggle = (car: typeof defaultFeaturedCars[0], e: React.MouseEvent) => {
    e.stopPropagation();
    toggleWishlist({
      id: car.id,
      name: car.name,
      price: car.price,
      mileage: car.mileage,
      location: car.location,
      badge: car.badge,
      images: car.images
    });
  };

  const handleCompare = () => {
    const vehiclesToCompare = featuredCars.filter(car => selectedForCompare.includes(car.id));
    navigate('/compare', { state: { vehicles: vehiclesToCompare } });
  };

  return (
    <section id="inventory" className="bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between mb-12">
          <h2 className="text-4xl font-bold text-gray-900">Featured Inventory</h2>
          <div className="flex items-center gap-4">
            {selectedForCompare.length > 0 && (
              <button
                onClick={handleCompare}
                className="px-6 py-3 bg-[#2563EB] text-white rounded-full font-medium hover:bg-[#1d4ed8] transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2"
              >
                <i className="ri-scales-line"></i>
                Compare ({selectedForCompare.length})
              </button>
            )}
            <button 
              onClick={() => navigate('/inventory')}
              className="text-[#2563EB] font-medium hover:underline flex items-center gap-2 cursor-pointer whitespace-nowrap"
            >
              View All Cars
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>

        <div className="overflow-x-auto pb-4 -mx-6 px-6">
          <div className="flex gap-6" style={{ width: 'max-content' }}>
            {featuredCars.map((car) => {
              const currentIndex = currentImageIndex[car.id] || 0;
              const isSelected = selectedForCompare.includes(car.id);
              const inWishlist = isInWishlist(car.id);
              return (
                <div
                  key={car.id}
                  data-product-shop
                  className={`bg-white rounded-3xl overflow-hidden transition-all duration-300 cursor-pointer ${
                    hoveredCard === car.id ? 'transform -translate-y-2 shadow-2xl' : 'shadow-lg'
                  } ${isSelected ? 'ring-4 ring-[#2563EB]' : ''}`}
                  style={{ width: '340px', flexShrink: 0 }}
                  onMouseEnter={() => setHoveredCard(car.id)}
                  onMouseLeave={() => setHoveredCard(null)}
                >
                  <div className="relative w-full h-64 bg-gray-100 group">
                    <img
                      src={car.images[currentIndex]}
                      alt={`${car.name} - Image ${currentIndex + 1}`}
                      className="w-full h-full object-cover object-top cursor-pointer"
                      onClick={() => openLightbox(car.id, currentIndex)}
                    />
                    <div className="absolute top-4 left-4 bg-[#2563EB] text-white px-4 py-1.5 rounded-full text-xs font-medium">
                      {car.badge}
                    </div>

                    {/* Action Buttons */}
                    <div className="absolute top-4 right-4 flex gap-2">
                      {/* Compare Checkbox */}
                      <button
                        onClick={(e) => toggleCompareSelection(car.id, e)}
                        className={`w-10 h-10 rounded-full flex items-center justify-center transition-all cursor-pointer shadow-lg ${
                          isSelected 
                            ? 'bg-[#2563EB] text-white' 
                            : 'bg-white/90 hover:bg-white text-gray-700'
                        }`}
                        title={isSelected ? 'Remove from comparison' : 'Add to comparison'}
                      >
                        {isSelected ? (
                          <i className="ri-check-line text-xl"></i>
                        ) : (
                          <i className="ri-scales-line text-xl"></i>
                        )}
                      </button>

                      {/* Wishlist Button */}
                      <button
                        onClick={(e) => handleWishlistToggle(car, e)}
                        className={`w-10 h-10 rounded-full flex items-center justify-center transition-all cursor-pointer shadow-lg ${
                          inWishlist
                            ? 'bg-red-500 text-white hover:bg-red-600'
                            : 'bg-white/90 hover:bg-white text-gray-700'
                        }`}
                        title={inWishlist ? 'Remove from wishlist' : 'Add to wishlist'}
                      >
                        <i className={`text-xl ${inWishlist ? 'ri-heart-fill' : 'ri-heart-line'}`}></i>
                      </button>
                    </div>

                    {/* Image Navigation Arrows */}
                    {car.images.length > 1 && (
                      <>
                        <button
                          onClick={(e) => handlePrevImage(car.id, car.images.length, e)}
                          className="absolute left-2 top-1/2 -translate-y-1/2 w-8 h-8 bg-white/90 hover:bg-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer shadow-lg"
                        >
                          <i className="ri-arrow-left-s-line text-gray-900"></i>
                        </button>
                        <button
                          onClick={(e) => handleNextImage(car.id, car.images.length, e)}
                          className="absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 bg-white/90 hover:bg-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer shadow-lg"
                        >
                          <i className="ri-arrow-right-s-line text-gray-900"></i>
                        </button>
                      </>
                    )}

                    {/* Image Indicators */}
                    {car.images.length > 1 && (
                      <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5">
                        {car.images.map((_, index) => (
                          <button
                            key={index}
                            onClick={(e) => {
                              e.stopPropagation();
                              setCurrentImageIndex(prev => ({ ...prev, [car.id]: index }));
                            }}
                            className={`w-1.5 h-1.5 rounded-full transition-all cursor-pointer ${
                              index === currentIndex ? 'bg-white w-6' : 'bg-white/60'
                            }`}
                          />
                        ))}
                      </div>
                    )}
                  </div>

                  <div className="p-6">
                    <h3 className="text-xl font-bold text-gray-900 mb-2">{car.name}</h3>
                    <p className="text-sm text-gray-500 mb-4">
                      {car.mileage} miles • {car.location}
                    </p>
                    <p className="text-3xl font-bold text-gray-900 mb-6">${car.price.toLocaleString()}</p>
                    <button 
                      onClick={() => handleViewDetails(car)}
                      className="w-full py-3.5 bg-[#2563EB] text-white rounded-full font-medium hover:bg-[#1d4ed8] transition-colors whitespace-nowrap"
                    >
                      View Details
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Lightbox Modal */}
      {lightboxOpen && currentLightboxCar && (
        <div 
          className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center"
          onClick={closeLightbox}
        >
          <div className="relative w-full h-full flex items-center justify-center p-4">
            {/* Close Button */}
            <button
              onClick={closeLightbox}
              className="absolute top-6 right-6 w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center cursor-pointer transition-colors z-10"
            >
              <i className="ri-close-line text-white text-2xl"></i>
            </button>

            {/* Image Counter */}
            <div className="absolute top-6 left-6 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full z-10">
              <p className="text-white text-sm font-medium">
                {lightboxImageIndex + 1} / {currentLightboxCar.images.length}
              </p>
            </div>

            {/* Car Info */}
            <div className="absolute bottom-6 left-6 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-2xl z-10">
              <h3 className="text-white font-bold text-lg">{currentLightboxCar.name}</h3>
              <p className="text-white/80 text-sm">{currentLightboxCar.mileage} miles • {currentLightboxCar.location}</p>
            </div>

            {/* Main Image */}
            <img
              src={currentLightboxCar.images[lightboxImageIndex]}
              alt={`${currentLightboxCar.name} - Image ${lightboxImageIndex + 1}`}
              className="max-w-full max-h-full object-contain"
              onClick={(e) => e.stopPropagation()}
            />

            {/* Navigation Arrows */}
            {currentLightboxCar.images.length > 1 && (
              <>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    lightboxPrevImage();
                  }}
                  className="absolute left-6 top-1/2 -translate-y-1/2 w-14 h-14 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center cursor-pointer transition-colors"
                >
                  <i className="ri-arrow-left-s-line text-white text-3xl"></i>
                </button>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    lightboxNextImage();
                  }}
                  className="absolute right-6 top-1/2 -translate-y-1/2 w-14 h-14 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center cursor-pointer transition-colors"
                >
                  <i className="ri-arrow-right-s-line text-white text-3xl"></i>
                </button>
              </>
            )}

            {/* Thumbnail Strip */}
            {currentLightboxCar.images.length > 1 && (
              <div className="absolute bottom-6 right-6 flex gap-2 bg-white/10 backdrop-blur-sm p-2 rounded-xl">
                {currentLightboxCar.images.map((img, index) => (
                  <button
                    key={index}
                    onClick={(e) => {
                      e.stopPropagation();
                      setLightboxImageIndex(index);
                    }}
                    className={`w-16 h-16 rounded-lg overflow-hidden cursor-pointer transition-all ${
                      index === lightboxImageIndex ? 'ring-2 ring-white scale-110' : 'opacity-60 hover:opacity-100'
                    }`}
                  >
                    <img
                      src={img}
                      alt={`Thumbnail ${index + 1}`}
                      className="w-full h-full object-cover"
                    />
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </section>
  );
}
